module.exports = __webpack_public_path__ + "img/lightning.fd1c73a6.svg";